<script setup lang="ts">
const modals = useModalStore();
</script>

<template>
  <div>
    <Button
      type="button"
      variant="light"
      icon-start="fa-light fa-filter"
      small
      class="me-2"
      @click="modals.showModal('AddFilterDropdownModal')"
    >
      {{ $t("SV.LIT_Filters") }}
    </Button>
  </div>
</template>

<style scoped lang="postcss"></style>
